export default {
  plant: 'Plant',
  major: 'Major',
  majorSerialNo: 'Major - Serial No',
  dn: 'DN',
  cartonNo: 'Carton No',
  giDate: 'GI Date',
  pe: 'PE',
  productCode: 'Product Code',
  sku: 'SKU',
  dc: 'DC',
  size: 'Size',
  giQty: 'GI Qty',
  scannedEpcQty: 'Scanned EPC Qty',
  serialNoOfCtn: 'Serial No of CTN',
  client: 'Client',
  city: 'City',
  carrierVendorCode: 'Carrier Vendor Code',
  lastScannedDate: 'Last Scanned Date',
  actualWeight: 'Actual Weight',
  factoryCode: 'Factory Code',
  epc: 'EPC',
  epcDetail: 'EPC Detail',
  searchOptionError:
    'Major, Major-Serial No, DN, Carton Number, or GI Date must be filled in at least one of the five options!',
  maxInputError: 'A maximum of 50 input values is supported.',
  giDateOnlyRangeError: 'When only GI Date is selected, the search range cannot exceed 1 week.'
}
